/* global axios */
import ApiClient from './ApiClient';

class InboxTemplateFoldersAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  foldersUrl(inboxId) {
    return `${this.url}/${inboxId}/template_folders`;
  }

  list(inboxId) {
    return axios.get(this.foldersUrl(inboxId));
  }

  createFolder(inboxId, name) {
    return axios.post(this.foldersUrl(inboxId), {
      template_folder: { name },
    });
  }

  renameFolder(inboxId, folderId, name) {
    return axios.patch(`${this.foldersUrl(inboxId)}/${folderId}`, {
      template_folder: { name },
    });
  }

  deleteFolder(inboxId, folderId) {
    return axios.delete(`${this.foldersUrl(inboxId)}/${folderId}`);
  }

  assignTemplate(inboxId, { templateName, language, folderId }) {
    return axios.put(`${this.foldersUrl(inboxId)}/assign_template`, {
      template_name: templateName,
      language,
      folder_id: folderId === undefined ? null : folderId,
    });
  }
}

export default new InboxTemplateFoldersAPI();
